"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PaperAirplane: function() {
        return PaperAirplane;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const PaperAirplane = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M22.7071 1.29292C22.99 1.57578 23.077 2 22.9285 2.37142L14.9285 22.3714C14.7726 22.761 14.3901 23.0119 13.9706 22.9996C13.5512 22.9873 13.184 22.7144 13.0513 22.3163L10.2094 13.7906L1.68378 10.9487C1.28567 10.816 1.01276 10.4489 1.00044 10.0294C0.988109 9.60994 1.23898 9.2274 1.62861 9.07155L21.6286 1.07155C22 0.922983 22.4242 1.01006 22.7071 1.29292ZM12.1441 13.2701L14.0854 19.0939L19.2621 6.1521L12.1441 13.2701ZM17.8479 4.73789L4.90608 9.91463L10.7299 11.8559L17.8479 4.73789Z",
        fill: "currentColor"
    })
}), "PaperAirplane");
const _default = PaperAirplane;
